import React from 'react'
import { FormattedMessage } from 'react-intl'

export const APPLICATIONS_AND_INVITES = (
    <FormattedMessage
        id="clanmanagement.caption.applications_and_invites"
        defaultMessage="Заявки и приглашения:"
    />
)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Inbox/translations.js